import { SvgIconProps } from './icon-props';

export default function CallAlt({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg
			viewBox="0 0 32 32"
			version="1.2"
			baseProfile="tiny-ps"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
		>
			<path
				fillRule="evenodd"
				d="M27.5 27.5H27A22.538 22.538 0 0 1 4.49 4.99v-.5h9.46v6.85l-3.22 1.61c.44.89.95 1.75 1.53 2.56.58.81 1.23 1.57 1.93 2.28a18.317 18.317 0 0 0 4.84 3.46l1.61-3.22h6.85v9.46zM5.51 5.5c.07 2.74.66 5.44 1.73 7.95 1.08 2.52 2.63 4.81 4.56 6.74 1.94 1.94 4.22 3.49 6.74 4.56 2.52 1.08 5.22 1.67 7.95 1.73v-7.46h-5.23l-1.77 3.54-.44-.2a19.46 19.46 0 0 1-5.56-3.87c-.8-.8-1.53-1.68-2.18-2.61-.65-.93-1.21-1.92-1.69-2.95l-.2-.44 3.54-1.77V5.49H5.5z"
			/>
		</svg>
	);
}
